import { DynamicFormV2Palette } from "@mui/material";

export type FormBlockTokenType = {
  textColor: string;
  cardBackgroundColor: string;
  cardBorderColor: string;
};

export const assignBlockComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDullMode: boolean
) => {
  const isLightMode = mode === "light";

  const cardBackgroundColor = isLightMode ? formsPalette.surface.reverse : formsPalette.surface.quiet;

  return {
    textColor: formsPalette.text.moderate,
    cardBackgroundColor,
    cardBorderColor: isLightMode && isDullMode ? formsPalette.border.intense : cardBackgroundColor,
  } as FormBlockTokenType;
};
